<template>
    <Nav />
    <Content>
        <PostEditor v-if="isAdmin" />
        <ErrorPage v-else />
    </Content>
    <Footer />
</template>
<script>
import Nav from '@/components/Nav.vue'
import Content from '@/components/Content.vue'
import Footer from '@/components/Footer.vue'
import PostEditor from '@/components/editor/PostEditor.vue'
import ErrorPage from '@/components/ErrorPage.vue'
import { mapGetters } from 'pinia'
import { useLogin } from '@/js/auth.js'

export default {
    name: 'EditorView',
    components: { Nav, Footer, Content, PostEditor, ErrorPage },
    computed: {
        ...mapGetters(useLogin, ["isAdmin"]),
    }
}
</script>